import { Collapse, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import ReadMore from '../../../assets/images/read-more.svg';
import { MAX_PROJECT_DESCRIPTION } from '../../../config';
import { COLORS } from '../../../constants/colors';
import { PROJECT } from '../../../constants/props';
import Skill from '../../skills/skill';

const useStyles = makeStyles({
  root: {
    marginLeft: '5.5625rem',
    '&:not(:last-of-type)': {
      marginBottom: '1.6875rem',
    },
    paddingBottom: '1.25rem',
    '&:last-of-type': {
      paddingBottom: '.75rem',
    },
    borderBottom: `2px solid  ${COLORS.primary.main}`,
    '@media (max-width:439px)': {
      marginLeft: '2rem',
    },
    '@media (max-width:359px)': {
      marginLeft: '1rem',
    }
  },
  title: {
    marginBottom: '.75rem',
    fontSize: '1.25rem',
    lineHeight: '150%',
    textTransform: 'uppercase',
  },
  skill: {
    marginRight: '.625rem',
    marginBottom: '1rem',
  },
  collapse: {
    marginBottom: '2rem',
    height:'auto',
  },
  description: {
    fontSize: '1.25rem',
    lineHeight: '150%',
  },
  more: {
    height: '1.5rem',
    padding: '0 .5rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const View = ({ name, description, skills }) => {
  const [collapsed, setCollapsed] = useState(description.length < MAX_PROJECT_DESCRIPTION);
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
      <Typography
        className={classes.title}
        color="textSecondary"
      >{`Project: ${name}`}</Typography>
      <Collapse
        className={classes.collapse}
        in={collapsed}
        collapsedHeight={64}
      >
        <Typography className={classes.description}>
          {!collapsed ? (
            <>
              {description.slice(0, MAX_PROJECT_DESCRIPTION).concat(' ...')}
              <img
                className={classes.more}
                src={ReadMore}
                alt="Read more button"
                role="button"
                onClick={() => setCollapsed(true)}
              />
            </>
          ) : (
            description
          )}
        </Typography>
      </Collapse>
      <Grid container>
        {skills.map((skill, index) => (
          <div key={`skill-${index}`} className={classes.skill}>
            <Skill {...skill} />
          </div>
        ))}
      </Grid>
    </Grid>
  );
};

View.propTypes = {
  PROJECT,
};

export default View;
